/** Protected and system comments are the submission's record: nobody edits or deletes them. */
export function isSubmissionRecordComment(comment: {
  isProtected?: boolean | null;
  isSystemMessage?: boolean | null;
}): boolean {
  return Boolean(comment.isProtected || comment.isSystemMessage);
}

/** Starts the protected comment holding a reviewer's rejection reason; reports find rejections by it. */
export const REVIEWER_REJECTION_PREFIX = "Rejected by reviewer:";
